// this should be avoided, but we need this cuz of old scripts
window.isMobile = window.matchMedia("only screen and (max-width: 767px)");



// WEBPACK FOOTER //
// ./src/browser/oldJs/lib/windowUtils.js